
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/404",
      function () {
        return require("private-next-pages/mobiworkx/404.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/404"])
      });
    }
  